import script from "./udfDetailsPanel.vue?vue&type=script&lang=js"
export * from "./udfDetailsPanel.vue?vue&type=script&lang=js"

import "./udfDetailsPanel.vue?vue&type=style&index=0&id=7d10f137&scoped=true&lang=css"
import "./udfDetailsPanel.vue?vue&type=style&index=1&id=7d10f137&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d10f137"]])

export default __exports__